<div class="reset-password" (keydown.enter)="onSubmit()">
  <div class="form-element">
    <app-text-field
      [formControl]="emailControl"
      id="username"
      name="username"
      label="{{ 'mail' | translate }}"
      placeholder="{{ 'enter_your_e-mail' | translate }}"
      [error]="emailControl.invalid && emailControl.touched"
    >
    </app-text-field>
    @if (emailControl.touched && emailControl.invalid) {
      <mat-hint class="text-danger">
        @if (emailControl.errors?.['required']) {
          {{ 'please_enter_email' | translate }}
        }
        @if (emailControl.errors?.['email']) {
          {{ 'please_enter_valid_email' | translate }}
        }
      </mat-hint>
    }
  </div>
  <app-button [disabled]="isSending" (onChangeClick)="onSubmit()" [full]="true">
    {{ 'reset_password.btn' | translate }}
  </app-button>
</div>
